import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { useIsRestorationProject } from '@/pages/shared/projects/pages/project/pages/conservation/restoration/hooks/useIsRestorationProject';
import { WaterCard } from '@/pages/shared/projects/pages/project/pages/conservation/restoration/pages/water/components/Card';
import { LandMonitoringProjectPageWrapper } from '@/pages/shared/projects/pages/project/pages/sustainableProduction/components/LandMonitoring.page-wrapper';

export const WaterDetailPage = () => {
  const { t } = useTranslation();
  const isRestorationProject = useIsRestorationProject();

  if (!isRestorationProject) {
    throw new Error('Water page is only accesible for restoration projects');
  }

  return (
    <LandMonitoringProjectPageWrapper title={t('shared.ncaDetail.details.water.labels.water')}>
      <Stack spacing={8}>
        <WaterCard />
      </Stack>
    </LandMonitoringProjectPageWrapper>
  );
};
